import React, { PureComponent } from 'react';

import classNames from 'classnames';
import { Card } from 'components/card';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

class SubtitleBaseCardHeader extends PureComponent {
  static propTypes = {
    label: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node
  };

  get className() {
    return classNames('subtitle__card__header', this.props.className);
  }

  render() {
    const { label, children } = this.props;

    return (
      <div className={this.className}>
        <label className="subtitle__card__header__description label__description">
          <I18n label={label} />
        </label>

        {children}
      </div>
    );
  }
}

class SubtitleBaseCardContent extends PureComponent {
  static propTypes = {
    children: PropTypes.node
  };

  render() {
    const { children } = this.props;

    return <div className="subtitle__card__content">{children}</div>;
  }
}

export default class SubtitleCard extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    small: PropTypes.bool,
    medium: PropTypes.bool
  };

  static Header = SubtitleBaseCardHeader;
  static Content = SubtitleBaseCardContent;

  get className() {
    const { small, medium, className } = this.props;

    return classNames('subtitle__card', className, {
      'subtitle__card--sm': small,
      'subtitle__card--md': medium
    });
  }

  render() {
    const { children } = this.props;

    return <Card className={this.className}>{children}</Card>;
  }
}
